import apiClient from 'utilities/apiClient';

export const staff_projects = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.staffing}/${url}`, payload, true);
};

export const staff_users = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.staffing}/${url}`, payload, true);
};

export const assign_project = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.staffing}/${url}`, payload, true);
};

export const user_roles = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.staffing}/${url}`, payload, true);
};
